import script from "./PlayerBoards.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayerBoards.vue?vue&type=script&setup=true&lang=ts"

import "./PlayerBoards.vue?vue&type=style&index=0&id=3fda95f2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fda95f2"]])

export default __exports__